import { render } from "./dstv.vue?vue&type=template&id=978c4ac8&scoped=true"
import script from "./dstv.vue?vue&type=script&lang=js"
export * from "./dstv.vue?vue&type=script&lang=js"

import "./dstv.vue?vue&type=style&index=0&id=978c4ac8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\user\\Desktop\\tap-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-978c4ac8"]])

export default __exports__